export default __webpack_public_path__ + "static/media/flag-bahrain.0b2590b8.svg";